import { handleApiCall } from "./HandleApi";
import config from "../config.json"


export const _getLink = (dataObj) => {
  return handleApiCall(
    {
      url: config.get_link_url,
      method: "post",
      dataObj: dataObj,
      headers:{"Content-Type": "application/x-www-form-urlencoded"},
      requestBody:{type:Object,encryption:true,queryString:true},
      responseBody: { decryption: true },
    },
    true,
  );
};